export const movieList = [
  {
    id: 'm1',
    title: '长安夜行',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20capital%20at%20night%20with%20warm%20lantern%20glow%2C%20palace%20architecture%20and%20silk%20drapes%2C%20cinematic%20poster%20style%2C%20rich%20warm%20tones%2C%20clean%20premium%20background&width=600&height=800&seq=movie-cover-01&orientation=portrait',
    year: 2026,
    type: '电影',
    genre: '古装 / 剧情',
    region: '中国大陆',
    director: '顾行舟',
    cast: ['沈知远', '白鹭', '陆清和'],
    intro: [
      '一座繁华的古都，在夜色中藏着无数未解的谜题。年轻的巡查官在一次意外中卷入连环悬案，不得不与神秘的说书人联手追查真相。',
      '随着线索逐渐清晰，一段被掩埋多年的往事浮出水面，而每个人似乎都在这段往事里留下了自己的影子。',
    ],
    rating: 9.1,
  },
  {
    id: 'm2',
    title: '雾城谜影',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20foggy%20city%20at%20night%20with%20warm%20streetlight%20glow%2C%20rain%20reflections%20on%20streets%2C%20cinematic%20suspense%20poster%20style%2C%20clean%20dramatic%20background&width=600&height=800&seq=movie-cover-02&orientation=portrait',
    year: 2026,
    type: '电视剧',
    genre: '悬疑 / 都市',
    region: '中国大陆',
    director: '程见微',
    cast: ['秦舟', '苏叶', '何知遇'],
    intro: [
      '在这座常年被雾气笼罩的城市里，一桩看似普通的失踪案，牵出了维持多年的秘密网络。',
      '调查记者与刑警在一次次交锋中逐渐建立信任，却发现彼此追寻的真相，指向的是同一段不愿被提起的过去。',
    ],
    rating: 8.8,
  },
  {
    id: 'm3',
    title: '引力边境',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20scene%20with%20giant%20warm%20planet%20and%20lone%20spaceship%2C%20cinematic%20concept%20poster%2C%20soft%20glow%2C%20clean%20dramatic%20background&width=600&height=800&seq=movie-cover-03&orientation=portrait',
    year: 2026,
    type: '电影',
    genre: '科幻 / 冒险',
    region: '中国大陆',
    director: '江野',
    cast: ['顾南舟', '温宁', '纪川'],
    intro: [
      '当人类的脚步第一次抵达恒星系的边缘，一支科考船队却意外失联。多年以后，一段残缺的讯号重新被捕捉到。',
      '为了找回失联的同伴，也为了解答一个关乎存续的问题，新的远征队踏上了一场没有归途的旅程。',
    ],
    rating: 8.6,
  },
  {
    id: 'm4',
    title: '晚风告白',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20riverside%20city%20at%20sunset%20with%20warm%20glow%2C%20soft%20bokeh%20lights%2C%20cinematic%20romance%20poster%20style%2C%20cozy%20warm%20background&width=600&height=800&seq=movie-cover-04&orientation=portrait',
    year: 2026,
    type: '电影',
    genre: '爱情 / 剧情',
    region: '中国大陆',
    director: '林知夏',
    cast: ['白鹭', '许清欢'],
    intro: [
      '两个习惯把心事藏在晚风里的人，在一座临河的小城里反复错过。命运给了他们无数次擦肩，也给了他们一次郑重告白的机会。',
      '影片用细腻的日常片段，讲述一段关于勇气与等待的故事。',
    ],
    rating: 8.3,
  },
  {
    id: 'm5',
    title: '星厨来客',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20kitchen%20with%20steaming%20homestyle%20dishes%2C%20golden%20light%2C%20lifestyle%20poster%20style%2C%20clean%20warm%20background&width=600&height=800&seq=movie-cover-05&orientation=portrait',
    year: 2026,
    type: '综艺',
    genre: '美食 / 真人秀',
    region: '中国大陆',
    director: '综艺频道出品',
    cast: ['陈默', '吴桐'],
    intro: [
      '节目走进普通人的厨房，用一道道家常菜串起真实的人生故事。没有紧张刺激的淘汰，只有灶台边的温暖与交流。',
      '每一期，都会有一位素人带来自己的拿手菜，以及这道菜背后的一段记忆。',
    ],
    rating: 8.9,
  },
  {
    id: 'm6',
    title: '我们的乐队',
    cover: 'https://readdy.ai/api/search-image?query=Live%20rock%20band%20on%20stage%20with%20warm%20orange%20lights%2C%20guitars%20and%20drums%2C%20concert%20poster%20style%2C%20energetic%20clean%20background&width=600&height=800&seq=movie-cover-06&orientation=portrait',
    year: 2026,
    type: '综艺',
    genre: '音乐 / 竞演',
    region: '中国大陆',
    director: '综艺频道出品',
    cast: ['许安', '乐队嘉宾'],
    intro: [
      '不同风格的音乐人自由组队，在同一個舞台上共创属于自己的作品。协作、碰撞与成长，构成了这档节目的主线。',
      '本季赛制更强调乐队成员之间的默契，也让更多优秀的独立音乐人走到台前。',
    ],
    rating: 8.7,
  },
  {
    id: 'm7',
    title: '山河之间',
    cover: 'https://readdy.ai/api/search-image?query=Serene%20mountain%20landscape%20at%20golden%20hour%2C%20soft%20warm%20light%2C%20documentary%20poster%20style%2C%20minimal%20calm%20background&width=600&height=800&seq=movie-cover-07&orientation=portrait',
    year: 2025,
    type: '综艺',
    genre: '纪录片',
    region: '中国大陆',
    director: '郑野',
    cast: ['纪录团队'],
    intro: [
      '摄制组历时两年走访多地，记录下一群普通人日复一日的坚持。影片没有宏大的旁白，只把镜头长久地停留在日常里。',
      '在山河之间，那些看似平凡的选择，往往藏着最动人的力量。',
    ],
    rating: 9.0,
  },
  {
    id: 'm8',
    title: '暗涌',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20industrial%20harbor%20at%20night%20with%20warm%20orange%20lights%2C%20smoke%20and%20reflections%2C%20crime%20thriller%20poster%20style%2C%20clean%20dramatic%20background&width=600&height=800&seq=movie-cover-08&orientation=portrait',
    year: 2025,
    type: '电视剧',
    genre: '犯罪 / 悬疑',
    region: '中国大陆',
    director: '程见微',
    cast: ['秦舟', '纪川'],
    intro: [
      '港口城市的表面平静之下，涌动着看不见的暗流。一名老刑警在退休前的最后一起案件里，撞见了自己不愿面对的往事。',
      '随着调查深入，正义与代价之间的界限变得愈发模糊。',
    ],
    rating: 8.5,
  },
  {
    id: 'm9',
    title: '少年逐光',
    cover: 'https://readdy.ai/api/search-image?query=Young%20athletes%20training%20at%20sunrise%20with%20warm%20golden%20light%2C%20running%20track%2C%20inspirational%20cinematic%20poster%20style%2C%20clean%20warm%20background&width=600&height=800&seq=movie-cover-09&orientation=portrait',
    year: 2025,
    type: '电视剧',
    genre: '青春 / 运动',
    region: '中国大陆',
    director: '林知夏',
    cast: ['许清欢', '温宁'],
    intro: [
      '一群来自不同背景的少年，因为一项运动走到了一起。他们要在一次次的失败中，学会相信彼此，也学会相信自己。',
      '青春最动人的地方，或许就是无论跌倒多少次，都还愿意向着光奔跑。',
    ],
    rating: 8.4,
  },
  {
    id: 'm10',
    title: '万家灯火',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20residential%20neighborhood%20at%20dusk%20with%20glowing%20windows%2C%20cozy%20family%20atmosphere%2C%20heartwarming%20drama%20poster%20style%2C%20clean%20warm%20background&width=600&height=800&seq=movie-cover-10&orientation=portrait',
    year: 2024,
    type: '电视剧',
    genre: '家庭 / 生活',
    region: '中国大陆',
    director: '周叙',
    cast: ['何知遇', '赵岚'],
    intro: [
      '一条老街上，几户人家过着各自琐碎却真实的日子。柴米油盐之间，藏着最踏实的幸福，也藏着最难解的心结。',
      '当聚散离合成为生活的常态，人们才慢慢明白，灯火可亲本身就是一种圆满。',
    ],
    rating: 8.2,
  },
  {
    id: 'm11',
    title: '极昼之城',
    cover: 'https://readdy.ai/api/search-image?query=Northern%20city%20under%20endless%20daylight%20with%20warm%20low%20sun%2C%20modern%20architecture%2C%20cinematic%20poster%20style%2C%20clean%20cool%20warm%20background&width=600&height=800&seq=movie-cover-11&orientation=portrait',
    year: 2024,
    type: '电影',
    genre: '悬疑 / 科幻',
    region: '中国大陆',
    director: '江野',
    cast: ['顾南舟', '苏叶'],
    intro: [
      '在一座太阳不再落下的城市里，时间失去了原本的意义。一名气象学者的失踪，让所有的秩序开始松动。',
      '当白昼无限延长，人们才意识到，黑暗或许正是理解光明的必要条件。',
    ],
    rating: 8.0,
  },
  {
    id: 'm12',
    title: '纸上江湖',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20calligraphy%20desk%20with%20ink%20and%20brush%2C%20warm%20lamp%20glow%2C%20artistic%20wuxia%20poster%20style%2C%20clean%20elegant%20background&width=600&height=800&seq=movie-cover-12&orientation=portrait',
    year: 2024,
    type: '电影',
    genre: '武侠 / 剧情',
    region: '中国大陆',
    director: '顾行舟',
    cast: ['陆清和', '白鹭'],
    intro: [
      '一名以字为剑的落魄书生，为了一封未曾寄出的信，踏入了早已平息多年的江湖。',
      '纸上的刀光与现实的恩怨交叠，最终他要面对的，是自己写下的那一个选择。',
    ],
    rating: 8.1,
  },
];